type SessionCacheEntry<T> = {
  paymentConfig: T;
  expirationTime: number;
};

export const parseMaxAgeSeconds = (cacheControl: string | undefined | null): number => {
  if (!cacheControl) return 0;

  const match = /max-age=(\d+)/i.exec(cacheControl);
  return match ? Number(match[1]) : 0;
};

const readSessionEntry = <T>(storageKey: string): SessionCacheEntry<T> | null => {
  try {
    const raw = sessionStorage.getItem(storageKey);
    if (!raw) return null;

    return JSON.parse(raw) as SessionCacheEntry<T>;
  } catch {
    return null;
  }
};

const writeSessionEntry = <T>(storageKey: string, entry: SessionCacheEntry<T>) => {
  sessionStorage.setItem(storageKey, JSON.stringify(entry));
};

export const getFromSessionOrFetch = async <T>(
  storageKey: string,
  fetchFn: () => Promise<{ data: T; maxAgeSeconds: number }>
): Promise<T> => {
  const cached = readSessionEntry<T>(storageKey);

  if (cached && Date.now() < cached.expirationTime) {
    return cached.paymentConfig;
  }

  const { data, maxAgeSeconds } = await fetchFn();
  const expirationTime = Date.now() + maxAgeSeconds * 1000;

  writeSessionEntry(storageKey, { paymentConfig: data, expirationTime });

  return data;
};
